var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "two-column-wrapper" }, [
    _c(
      "div",
      { staticStyle: { margin: "auto", "max-width": "880px" } },
      [_vm._t("data-body")],
      2
    ),
    _vm._v(" "),
    _c("div", [_vm._t("data-details")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }